// AdvertisementCard.js
import style from "./AdvertisementCard.module.css";
import { LuEye } from "react-icons/lu";
import { PiShareFat } from "react-icons/pi";
import {
  MdDeleteForever,
  MdOutlineEdit,
  MdDownloadDone,
  MdOutlineShoppingCart,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { productApi } from "../../apis/ProductListing.apis";
import { formattedAmount } from "../../utils/helpers/Functions.helper";
import { FaDotCircle } from "react-icons/fa";

const AdvertisementCard = ({ adData, handleEditOpen, handleDelete }) => {
  const { theme } = useSelector((state) => state.theme);
  console.log("adData:", adData);

  return (
    <>
      <div
        className={`${
          theme === "light"
            ? "bg-secondaryColor text-primaryColor"
            : "bg-darkThirsary text-darkSecondary"
        } ${style.advertisement_card}`}
        key={adData.id}
      >
        <div className="relative">
          <img
            className={style.advertisement_image}
            src={adData.image}
            alt={adData.title}
          />

          {/* Edit and Delete buttons */}
        </div>
        <div className=" p-2">
          <p
            className={`${
              adData.status === "Pending"
                ? "text-yellow500"
                : adData.status === "Approved"
                ? "text-green500"
                : adData.status === "Rejected"
                ? "text-red600"
                : ""
            } flex items-center gap-1 justify-end`}
          >
            <span
              className={`${
                adData.status === "Pending"
                  ? "text-yellow500"
                  : adData.status === "Approved"
                  ? "text-green500"
                  : adData.status === "Rejected"
                  ? "text-red500"
                  : ""
              }`}
            >
              <FaDotCircle />
            </span>
            {adData.status}
          </p>
          <div className="flex justify-end gap-2 mt-1">
            <span
              onClick={() => handleEditOpen(adData)}
              className="p-1 text-green700 rounded-full bg-slate-100 hover:bg-gren100 border border-green500 transition-colors duration-200"
            >
              <MdOutlineEdit className="text-lg" />
            </span>
            <span
              onClick={() => handleDelete(adData)}
              className="p-1 text-red700 rounded-full bg-slate-100 hover:bg-red100 border border-red500 transition-colors duration-200"
            >
              <MdDeleteForever className="text-lg" />
            </span>
          </div>
          <div className="">
            <h2
              className={`text-md ${
                theme === "light" ? "text-gray900" : "text-gray400"
              } font-semibold capitalize`}
            >
              {adData?.products?.name}
            </h2>
            <p
              className={`text-md ${
                theme === "light" ? "text-gray900" : "text-gray400"
              }  capitalize`}
            >
              Advertise for: {adData.advertisement_for}
            </p>
            <div className="flex gap-2">
              <p
                className={`text-md ${
                  theme === "light" ? "text-gray900" : "text-gray400"
                }  capitalize`}
              >
                Duration: {new Date(adData.start_date).toLocaleDateString()}
              </p>
              <p
                className={`text-md ${
                  theme === "light" ? "text-gray900" : "text-gray400"
                }  capitalize`}
              >
                {" "}
                to {new Date(adData.end_date).toLocaleDateString()}
              </p>
            </div>
            <p
              className={`text-md ${
                theme === "light" ? "text-gray900" : "text-gray400"
              }  capitalize`}
            >
              Budget: {formattedAmount(adData.advertisement_budget)}
            </p>
            <div className="flex justify-between px-2">
              <span className="flex flex-col items-center justify-center">
                <LuEye fontSize={"1.5rem"} />
                <span>{adData.advertise_views}</span>
              </span>
              <span className="flex flex-col items-center justify-center">
                <MdDownloadDone fontSize={"1.5rem"} />
                <span>{adData.ordered_by_advertise}</span>
              </span>
              <span className="flex flex-col items-center justify-center">
                <MdOutlineShoppingCart fontSize={"1.5rem"} />
                <span>{adData.addToCart_count}</span>
              </span>
              <span className="flex flex-col items-center justify-center">
                <PiShareFat fontSize={"1.5rem"} />
                <span>{adData.share}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvertisementCard;
